import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppName } from '@ot/dashboard/utils';
import { AuthModule, WalkmeModule } from '@ot/shared/utils';
import { FooterModule } from '@ot/shared/footer';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core.module';
import { SharedBaidPickerModule } from '@ot/shared/baid-picker';
import { SharedLegalNoticeModule } from '@ot/shared/legal-notice';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedBaidPickerModule,
    CoreModule,
    AuthModule,
    WalkmeModule,
    FooterModule
  ],
  providers: [{ provide: AppName, useFactory: () => environment.appName }],
  bootstrap: [AppComponent]
})
export class AppModule {}
